const englishLocaleConfig = {
    calendar : {
        sameDay : '[Today]',
        lastDay : '[Yesterday]',
        lastWeek : '[Last] dddd',
    },
};

const danishLocaleConfig = {
    calendar : {
        sameDay : '[I dag]',
        lastDay : '[I går]',
        lastWeek : '[Sidste] dddd',
    },
};

export { englishLocaleConfig, danishLocaleConfig };
